import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import RoleMutationModalsContainer from '../../components/SetupSubPageComps/RolesComps/RoleMutationModalsContainer';
import ShowAllRoles from '../../components/SetupSubPageComps/RolesComps/ShowAllRoles';
import RoleProvider from '../../contexts/RoleProvider';

const Roles = () => {
  // rendering roles page component here
  return (
    <>
      <PageTitle title='Roles' />

      <RoleProvider>
        <ShowAllRoles />
        <RoleMutationModalsContainer />
      </RoleProvider>
    </>
  );
};

export default Roles;
